import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

class AccountBtns extends Component {
	render() {
		return (
			<div className="account_section">
				{this.props.customer !== null ? (
					<span>
						<Link className="account-btn" to="/customer/">Account</Link>
						<Link to="/customer/logout">Logout</Link>
					</span>
				) : (
					<Link className="account-login-btn" to="/customer/login">Login</Link>
				)}
			</div>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		customer: state.user.customer
	}
}

export default connect(mapStateToProps)(AccountBtns)



// WEBPACK FOOTER //
// ./src/components/header/AccountBtns.js